import type CurrencyCode from '@alltrails/types/CurrencyCode';

// Prefixes align with what's used in the Conversions API, defined in:
// https://github.com/alltrails/lambda-amplitude-kinesis-integrations/blob/alpha/packages/handler/src/handler/params.py
const PURCHASE_EVENT_ID_PREFIX = 'subscription-psp-se';
const TRIAL_START_EVENT_ID_PREFIX = 'freetrial-pfts-se';
const SIGNUP_EVENT_ID_PREFIX = 'signup-ra';

export const trackPurchaseForReddit = ({
  userId,
  currencyCode,
  value,
  isTrial,
  subscription_event_id
}: {
  userId: number;
  currencyCode: CurrencyCode;
  value: number;
  isTrial: boolean;
  subscription_event_id?: number;
}) => {
  if (isRedditPixelUnavailable() || !subscription_event_id) {
    return;
  }

  if (isTrial) {
    rdt('track', 'TrialStart', {
      conversionId: `${TRIAL_START_EVENT_ID_PREFIX}-${subscription_event_id.toString()}`,
      externalId: userId
    });
  } else {
    rdt('track', 'Purchase', {
      currency: currencyCode,
      value,
      conversionId: `${PURCHASE_EVENT_ID_PREFIX}-${subscription_event_id.toString()}`,
      externalId: userId
    });
  }
};

export const trackCompleteRegistrationForReddit = (userId: number) => {
  if (isRedditPixelUnavailable()) {
    return;
  }

  rdt('track', 'SignUp', { conversionId: `${SIGNUP_EVENT_ID_PREFIX}-${userId}`, externalId: userId });
};

// Check for presence of rdt in case of content blockers
const isRedditPixelUnavailable = () => {
  return typeof rdt === 'undefined';
};
